import React, { useEffect, useState } from "react";
import { Box, Container, Typography, Stack, Button, Grid, AspectRatio } from "@mui/joy";
import Logo from "../../assets/svgs/logo.svg";
import { useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";
import GeekPlayer from "../../components/GeekPlayer";

const Home: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    ReactGA.event({
      category: "Landing Page",
      action: "Landing Page Viewed",
      label: "Landing Page Viewed"
    });
  }, []);

  const handleApplyForWork = () => {
    navigate("/apply/geek-app/all");
  };

  return (
    <Container
      sx={{
        height: "100vh",
        maxHeight: "100vh",
        overflow: "hidden",
        px: 1,
        py: 4
      }}
    >
      <Stack 
        direction="column"
        spacing={2} 
        maxWidth="xl"
        sx={{
          alignItems: "center",
          justifyContent: "center",
          height: "100%"
        }}
      >

        <Box sx={{ width: 72, height: 72 }}>
          <img src={Logo} alt="logo" />
        </Box>

        <Typography level="modalHeading" textAlign="center">
          GEEK matches you with the best hospitality jobs
        </Typography>

        <Typography
          level="description"
          textAlign="center"
          sx={{
            maxWidth: 600,
          }}
        >
          Join the hundreds of people using GEEK to get hired at their
          ideal hospitality job, with just a single application.
        </Typography>
        
        <Box sx={{ aspectRatio: "0.805", flexGrow: 1 }}>
          <GeekPlayer videoId="11646a4e-81c1-4c62-9607-2e30255163f8" aspectRatio="0.805" showMuteButton={false} showScrubber={false} />
        </Box>

        <Box sx={{ width: "500px", maxWidth: "80%", mt: "auto", my: 8 }}>
          <Button
            fullWidth
            variant="solid"
            onClick={handleApplyForWork}
          >
            Apply for Work
          </Button>
        </Box>
      </Stack>
    </Container>
  );
};

export default Home;
